import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const FinalizeMeetingUploadsApiSchema = {
    headers: ApiLambdalerAuthHeaderSchema.required({ requestActor: true }),
    params: z.object({
        entityId: CornSchema,
        startTime: z.string().datetime(),
    }),
    response: z.object({
        message: z.string(),
        details: z.unknown(),
    }),
};
export const FinalizeMeetingUploadsRequestSchema = FinalizeMeetingUploadsApiSchema.headers.merge(FinalizeMeetingUploadsApiSchema.params);
export const FinalizeMeetingUploadsResponseSchema = FinalizeMeetingUploadsApiSchema.response;
export const couldNotConvertMeetingErrorMessage = 'could not convert meeting';
